import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_ROUTES from "../../config/apiRoutes";


export const login = createAsyncThunk('auth/login', async ({ emailOrPhone, password }, { rejectWithValue }) => {
  try {
    console.log("checking env", process.env.REACT_APP_API_URL);
    const response = await axios.post(API_ROUTES.AUTH.LOGIN, {
      emailOrPhone,
      password,
    });
    
    const { access_token, admin } = response.data;
    localStorage.setItem('authToken', access_token);
    localStorage.setItem('admin', JSON.stringify(admin));
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    admin: JSON.parse(localStorage.getItem('admin')) || null,
    token: localStorage.getItem('authToken') || null,
    loading: false,
    error: null,
  },
  reducers: {
    logout(state) {
      state.token = null;
      state.admin = null;
      localStorage.removeItem('authToken'); 
      localStorage.removeItem('admin');
      // Redirect to login page only if not already there
      if (window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.access_token;
        state.admin = action.payload.admin;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
